import { SxProps, Theme } from '@mui/material/styles';
import { colorPalette } from 'stylesheet';

import { AdditionalIconButtonProps } from './IconButton';

const getIconButtonColor = (displayStyle: AdditionalIconButtonProps['displayStyle']) => {
  switch (displayStyle) {
    case 'grey':
      return colorPalette.greyMain;
    case 'orange':
      return colorPalette.secondary_600;
    case 'blue':
      return colorPalette.blue_600;
    case 'red':
      return colorPalette.status_error;
  }
};

export const getIconButtonSx = ({ displayStyle }: AdditionalIconButtonProps): SxProps<Theme> => ({
  color: getIconButtonColor(displayStyle),
  width: '50px',
  height: '50px',
  '&.MuiIconButton-sizeSmall': {
    width: '40px',
    height: '40px',
  },
});
